import { Vector3 } from "@babylonjs/core";
import type { DifficultyPreset } from "./Difficulty";

/** Produces a bounded lateral pursuit target; navigation still owns the actual route and collision response. */
export class AggressiveSteering {
  private phase = 0;

  constructor(private readonly seedPhase = 0) { this.reset(); }

  reset(): void { this.phase = this.seedPhase; }

  update(origin: Vector3, pursuitTarget: Vector3, deltaSeconds: number, difficulty: DifficultyPreset, scale = 1): Vector3 {
    const direct = pursuitTarget.subtract(origin); direct.y = 0;
    const distance = direct.length();
    if (distance <= .001 || difficulty.lateralSteeringStrength <= 0 || scale <= 0) return pursuitTarget.clone();
    this.phase += Math.max(0, deltaSeconds) * Math.PI / Math.max(.25, difficulty.lateralSteeringIntervalSeconds);
    direct.scaleInPlace(1 / distance);
    const lateral = new Vector3(-direct.z, 0, direct.x);
    const taper = Math.min(1, Math.max(0, distance - .7) / 2.3);
    const offset = Math.sin(this.phase) * difficulty.lateralSteeringStrength * 3 * taper * scale;
    return pursuitTarget.add(lateral.scale(offset));
  }
}
